import styled from 'styled-components';

export const Wrapper = styled.div``;

export const DropZone = styled.div<{
  color: string;
  borderColor?: string;
  height: string;
  width: string;
  fontSize: number | string;
  bgColor: string;
}>`
  background: ${({ bgColor }) => bgColor};
  border: 1px solid;
  border-color: ${({ borderColor, color }) => borderColor || color};
  color: ${({ color }) => color};
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: 600;
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 4px 24px;
  cursor: pointer;
  border-radius: 4px;

  svg {
    fill: ${({ color }) => color};
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-color: var(--colorBlueGray1300);
  opacity: 0.8;
  z-index: 9999;
`;

export const ErrorModal = styled.div`
  position: fixed;
  border-radius: 8px;
  box-shadow: 0px 11px 15px -7px rgb(0 0 0 / 32%), 0px 9px 46px 8px rgb(0 0 0 / 20%),
    0px 24px 38px 3px rgb(0 0 0 / 24%);
  width: 368px;
  max-height: calc(100vh - 192px);
  overflow: auto;
  z-index: 9999;
  background-color: var(--colorWhite);
  top: 96px;
  left: 0;
  right: 0;
  margin: 0 auto;
  padding: 24px;
`;

export const Error = styled.p`
  color: var(--colorUIRed);
  margin-bottom: 8px;
  font-size: 14px;

  &:last-child {
    margin-bottom: 0;
  }
`;
